<template>
  <div
    class="booking-header-detail"
    data-component="booking-header-detail"
  >
    <booking-header-extension v-if="selectedHotel && dayFormat">
      <div class="booking-header-extension-left">
        <div class="location">
          {{ selectedHotel.fullHotelName }}
        </div>
      </div>
      <div class="booking-header-extension-right">
        <div class="booking-header-extension-info">
          <div class="date-wrapper">
            <button
              class="date"
              :class="{ disabled: isBookingEditMode && isMultiRoomReservation }"
              :tabindex="isBookingEditMode && isMultiRoomReservation ? '-1' : '0'"
              :aria-label="bookingDateRange({isAria: true})"
              @click.prevent="handleClick"
              @keydown.space.prevent="handleClick"
            >
              {{
                bookingDateRange()
              }}
            </button>
            <v-dropdown
              v-if="isBookingEditMode && isMultiRoomReservation && !!modifyBookingPropData.ModifyReservationDateWarning"
              class="tooltip tooltip-variant--date-picker"
              popper-class="booking-modify-tooltip"
              placement="top"
              :distance="22"
              :skidding="0"
            >
              <button
                class="tooltip-icon icon-info"
                role="presentation"
                :aria-label="modifyBookingPropData.ModifyReservationDateWarning"
              />

              <template #popper>
                <div class="tooltip-variant--date-picker tooltip-content">
                  <div class="tooltip-header">
                    <span
                      v-close-popper
                      :aria-label="tc('booking.close')"
                      tabindex="0"
                      class="icon-close"
                    />
                  </div>
                  <div class="tooltip-body">
                    {{
                      modifyBookingPropData.ModifyReservationDateWarning
                    }}
                  </div>
                </div>
              </template>
            </v-dropdown>
          </div>
          <div class="marker" />
          <button
            class="occupancy"
            @click.prevent="$emit('edit', ['guests-and-rooms', $event.target])"
            @keydown.space.prevent="
              $emit('edit', ['guests-and-rooms', $event.target])
            "
          >
            <span
              class="summary"
            >
              {{ getSummaryDetails({capitalized: true}) }}
            </span>
          </button>
        </div>
      </div>
    </booking-header-extension>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { formatDateZone } from '@utils/date-helpers'
  import BookingHeaderExtension from '../booking-header-extension/booking-header-extension.vue'

  export default {
    name: 'BookingHeaderDetails',
    components: {
      BookingHeaderExtension,
    },
    computed: {
      ...mapState('booking', ['query']),
      ...mapState('modifyReservation', [
        'isBookingEditMode',
        'modifyBookingPropData',
      ]),
      ...mapGetters('booking', [
        'selectedHotel',
        'dayFormat',
        'getSummaryDetails',
        'isReady'
      ]),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('modifyReservation', ['isMultiRoomReservation']),
      ...mapGetters('booking', ['areDatesAndGuestsEmpty']),
    },
    watch: {
      isReady(newVal) {
        if (newVal) {
          this.openSidebarIfDatesEmpty()
        }
      }
    },
    mounted() {
      if (this.isReady) {
        this.openSidebarIfDatesEmpty()
      }
    },
    methods: {
      handleClick(event) {
        this.$emit('edit', ['calendar', event.target])
      },
      openSidebarIfDatesEmpty() {
        if (this.areDatesAndGuestsEmpty) {
          this.$nextTick(() => {
            this.$emit('edit', ['calendar', this.$el.querySelector('.date')])
          })
        }
      },
      bookingDateRange({ isAria = false } = {}) {
        const dateFormat = isAria ? 'dddd, D MMMM, YYYY' : 'ddd, D MMM, YYYY'
        return this.tc('booking.bookingDateRange', {
          startDate: formatDateZone(this.query.stayDateStart, null, dateFormat),
          endDate: formatDateZone(this.query.stayDateEnd, null, dateFormat)
        })
      }
    },
  }
</script>
